import { makeActionCreator } from '../actions/actionCreators';

export enum MenuActionTypes {
  MENU_DISABLED_CLICK = 'menu/disabled/click',
}

export const menuDisabledClick = makeActionCreator(MenuActionTypes.MENU_DISABLED_CLICK)();

export type MenuActions = ReturnType<typeof menuDisabledClick>;
